function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import clsx from 'clsx';
import { Avatar, Card, CardHeader, CardContent, Typography } from '@material-ui/core';
import { useStyles } from "./styles.js";
export const PostCard = ({
  title,
  image,
  date,
  excerpt,
  elevation,
  aosProps,
  authorName,
  authorAvatar,
  avatarClassName
}) => {
  const classes = useStyles({
    image
  });
  return /*#__PURE__*/React.createElement(Card, _extends({}, aosProps, {
    elevation: elevation,
    className: classes.card
  }), /*#__PURE__*/React.createElement(CardHeader, {
    avatar: /*#__PURE__*/React.createElement(Avatar, {
      alt: authorName,
      "aria-label": "author",
      src: authorAvatar,
      className: clsx(classes.avatar, avatarClassName)
    }),
    subheader: /*#__PURE__*/React.createElement(Typography, {
      align: "left",
      variant: "subtitle2",
      className: classes.cardText
    }, authorName)
  }), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
    align: "left",
    variant: "subtitle2",
    className: classes.cardText
  }, date), /*#__PURE__*/React.createElement(Typography, {
    align: "left",
    variant: "h6",
    className: classes.cardText,
    gutterBottom: true
  }, title), /*#__PURE__*/React.createElement(Typography, {
    align: "left",
    component: "p",
    className: classes.cardText,
    gutterBottom: true
  }, excerpt)));
};
PostCard.defaultProps = {
  elevation: 0,
  aosProps: {
    'data-aos': 'fade-up',
    'data-aos-once': 'true'
  }
};
PostCard.displayName = 'PostCard';
export default PostCard;